import { ILogger, ILogMethod } from "./ILogger";

function consoleLoggerMethod(
    level: "log" | "error" | "warn" | "debug" | "info",
): ILogMethod {
    return function logMethod(this: ILogger, message: any, ...meta: any[]) {
        console[level](message, meta);
        return this;
    };
}

export const consoleLogger: ILogger = {
    error: consoleLoggerMethod("error"),
    warn: consoleLoggerMethod("warn"),
    info: consoleLoggerMethod("info"),
    debug: consoleLoggerMethod("debug"),
    silly: consoleLoggerMethod("debug"),
};

function noopLoggerMethod(this: ILogger) {
    return this;
}

export const noopLogger: ILogger = {
    error: noopLoggerMethod,
    warn: noopLoggerMethod,
    info: noopLoggerMethod,
    debug: noopLoggerMethod,
    silly: noopLoggerMethod,
};
